import { createStore } from 'redux'
import master from './master'
import {ProcessTimeSlots, arrayToJSONByID} from 'lib/helpers'

import {rewire} from 'redux-rewire-live'
import rewires from 'rewires'
import { TimeSlotActions, CardActions } from 'actions'
import _ from 'lodash'

let initialState = {
    session: {},
    organization: {},
    genders: [],
    breeds: [],
    appointmentTypes: [],
    classifications: [],
    page: 'loginOrSignup',
    completedPages: ['sessions'],
    patients: [],
    administrators: [],
    timeSlots: [],
    availabilities: [],
    filters: {},
    selectedPatients: {},
    selectedTimeSlot: {},
    selectedCard: {},
    shifts: {},
    serviceRegions: {},
    payments: {},
    config: {},
    invoiceItems: [],
    cards: {},
    loading: {},
    waitLists: {}
};

try{
    if(localStorage.getItem('state')){
        const _initialState = JSON.parse(
            localStorage.getItem('state')
        );
        initialState.session = _initialState.session

        initialState.cards = arrayToJSONByID(
            Object(_initialState.session).cards
        )
    }
}catch(error){
    console.log('Unable to parse state from localStorage');
}


let store = createStore(
    master,
    initialState
)

const rewiredStore = rewire(store, rewires)
window.minnowStore = rewiredStore

store.subscribe(()=>{
    const state = store.getState()
    localStorage.setItem('state', 
        JSON.stringify({
            session: _.omit(state.session, 'messages')
        })
    )
})

let oldAvailabilities = ''
store.subscribe(()=>{
    let newAvailabilities = JSON.stringify(store.getState().availabilities)
    let filters = store.getState().filters
    
    if(newAvailabilities != oldAvailabilities && filters.patientCount && filters.appointmentTypeID){
        oldAvailabilities = newAvailabilities
        TimeSlotActions.set(
            ProcessTimeSlots.all({
                startingAt: (store.getState().filters || {}).startDate,
                data: Object.values(store.getState().availabilities), 
                widgetAvailability: store.getState().organization.widgetAvailability,
                appointmentType: store.getState().appointmentTypes[filters.appointmentTypeID],
                patientCount: filters.patientCount,
                administrators: store.getState().administrators
            })
        )
    }
})
    
export default rewiredStore


// WEBPACK FOOTER //
// ./reducers/index.js